<div class="si-appo-arrival-turn-dialog" *ngIf="displayDialogArrivalTurn">
  <si-generic-dialog [displayDialog]="displayDialogArrivalTurn"
                     dialogTitle="SI_MY_TURN"
                     button1Text="SI_ACCEPT"
                     button1Class="si-button_main"
                     (displayDialogChange)="onChangeDisplayDialog($event)">
    <div class="mb-3">
      <si-appo-arrival-turn-item [ticketSequence]="model?.ticketSequence"
                                 [locationName]="model?.locationName"
                                 [actions]="['IS_MY_TURN']"
      ></si-appo-arrival-turn-item>
    </div>
    <si-appo-appointment-highlight [startDate]="startDateNumber"
                                   [centerName]="model.centerName"
                                   [serviceName]="model.serviceName"
                                   [professionalName]="model.professionalName"
                                   [reasonName]="model.reasonName"
                                   [assistanceTypeCode]="model.teleconsultation"
                                   [forceMobile]="true"
    ></si-appo-appointment-highlight>
  </si-generic-dialog>
</div>
